(() => {
  if (window.MCOCODHome) return;
  const instances = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const track = (event, parameters = {}) => {
    if (window.Shopify?.designMode) return;
    if (typeof window.gtag === 'function') window.gtag('event', event, parameters);
    else if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event, ...parameters });
  };

  function init(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const cleanups = [];
    const observers = [];
    const frames = new Set();
    const timers = new Set();
    const animations = new Set();
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const motion = () => root.dataset.mhAnimations !== 'false' && !reduced.matches;
    const behavior = () => motion() ? 'smooth' : 'instant';
    const on = (element, event, callback, options = {}) => {
      element?.addEventListener(event, callback, { ...options, signal: controller.signal });
    };
    const frame = callback => {
      const id = requestAnimationFrame(t => { frames.delete(id); callback(t); });
      frames.add(id);
    };
    const later = (callback, delay) => {
      const id = setTimeout(() => { timers.delete(id); callback(); }, delay);
      timers.add(id);
    };
    const observe = (element, callback, options) => {
      const observer = new IntersectionObserver(callback, options);
      observer.observe(element);
      observers.push(observer);
      return observer;
    };
    const animate = (element, keyframes, options) => {
      const animation = element.animate(keyframes, options);
      animations.add(animation);
      animation.finished.catch(() => {}).finally(() => animations.delete(animation));
      return animation;
    };
    root.dataset.mhMotion = motion() ? 'on' : 'off';
    on(reduced, 'change', () => {
      root.dataset.mhMotion = motion() ? 'on' : 'off';
      if (!motion()) {
        animations.forEach(a => a.finish());
        $$('.mh-rv').forEach(el => el.classList.remove('mh-rv', 'mh-in'));
      }
    });
    on(root, 'click', e => {
      const link = e.target.closest('[data-mh-event]');
      if (!link) return;
      const model = link.closest('[data-mh-model]')?.dataset.mhModel;
      track(link.dataset.mhEvent, {
        ...(model ? { model } : {}),
        ...(link.dataset.mhName ? { card_name: link.dataset.mhName } : {}),
        link_text: link.textContent.trim(), link_url: link.getAttribute('href')
      });
    });
    on(root, 'dragstart', e => {
      if (e.target.closest('img') || e.target.closest('a')?.querySelector('img')) e.preventDefault();
    });

    const openImages = $$('.mh-op-open[data-mh-src]');
    let openingsObserver;
    const observeOpenings = () => {
      openingsObserver?.disconnect();
      if (!fine.matches || !openImages.some(img => img.dataset.mhSrc)) return;
      openingsObserver = observe(root, entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        openImages.forEach(img => {
          if (!img.dataset.mhSrc) return;
          on(img, 'load', () => img.closest('.mh-op').classList.add('mh-open-ready'), { once: true });
          img.src = img.dataset.mhSrc;
          delete img.dataset.mhSrc;
        });
        openingsObserver.disconnect();
      }, { rootMargin: '600px 0px' });
    };
    if (openImages.length) { observeOpenings(); on(fine, 'change', observeOpenings); }

    $$('.mh-pcard').forEach(card => {
      const img = card.querySelector('.mh-pimg img');
      const links = card.querySelectorAll('.mh-pimg, .mh-pbody');
      const buttons = [...card.querySelectorAll('.mh-sw')];
      const pill = card.querySelector('.mh-swatches');
      const tag = card.querySelector('.mh-sw-name');
      if (!img || !buttons.length) return;
      const pendingImages = new Set();
      cleanups.push(() => {
        pendingImages.forEach(image => { image.onload = null; image.onerror = null; });
        img.classList.remove('mh-is-swapping');
      });
      const initial = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), sizes: img.getAttribute('sizes') };
      const initialButton = buttons.find(button => button.getAttribute('aria-checked') === 'true') || null;
      let selected = initialButton;
      let shown = selected, request = 0, preloaded = false;
      const ring = button => buttons.forEach(b => b.classList.toggle('mh-is-shown', b === button));
      const swap = button => {
        const source = button?.dataset.mhSrc;
        const token = ++request;
        shown = button;
        if (!source || button === initialButton) {
          img.src = initial.src;
          if (initial.srcset) img.setAttribute('srcset', initial.srcset); else img.removeAttribute('srcset');
          if (initial.sizes) img.setAttribute('sizes', initial.sizes);
          img.classList.remove('mh-is-swapping');
          return;
        }
        img.classList.add('mh-is-swapping');
        const preload = new Image();
        const release = () => { preload.onload = null; preload.onerror = null; pendingImages.delete(preload); };
        pendingImages.add(preload);
        preload.onload = () => {
          if (token === request && !controller.signal.aborted) {
            img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = source;
            img.classList.remove('mh-is-swapping');
          }
          release();
        };
        preload.onerror = () => { if (token === request) img.classList.remove('mh-is-swapping'); release(); };
        preload.src = source;
      };
      const show = button => {
        if (button && button !== initialButton && !button.dataset.mhSrc) return;
        ring(button); if (shown !== button) swap(button);
      };
      const label = button => {
        tag.textContent = button ? button.getAttribute('aria-label') + (button.classList.contains('mh-is-soldout') ? ' · Sold out' : '') : '';
        tag.classList.toggle('mh-on', !!button);
      };
      ring(selected);
      const select = button => {
        selected = button;
        buttons.forEach(b => { b.setAttribute('aria-checked', String(b === button)); b.tabIndex = b === button ? 0 : -1; });
        show(button);
        if (button.dataset.mhVariant) links.forEach(a => a.href = `${card.dataset.mhUrl}?variant=${button.dataset.mhVariant}`);
      };
      on(card, 'pointerenter', () => {
        if (!fine.matches || preloaded) return;
        preloaded = true;
        buttons.forEach(b => { if (b.dataset.mhSrc) new Image().src = b.dataset.mhSrc; });
      }, { passive: true });
      buttons.forEach((button, i) => {
        on(button, 'pointerenter', () => {
          if (!fine.matches) return;
          show(button); label(button);
          track('home_swatch_hover', { model: card.dataset.mhModel, color: button.getAttribute('aria-label') });
        });
        on(button, 'focus', () => { show(button); label(button.matches(':focus-visible') ? button : null); });
        on(button, 'blur', () => label(null));
        on(button, 'click', () => select(button));
        on(button, 'keydown', e => {
          const delta = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
          if (!delta) return;
          e.preventDefault();
          const next = buttons[(i + delta + buttons.length) % buttons.length];
          select(next); next.focus();
        });
      });
      on(pill, 'pointerleave', () => { show(selected); label(null); });
      on(pill, 'focusout', e => { if (!pill.contains(e.relatedTarget)) { show(selected); label(null); } });
    });

    const comparison = $('.mh-cmp');
    let resetComparison = () => {};
    if (comparison) {
      const knob = $('.mh-cmp-knob');
      let drag = false, used = false, hinted = false;
      const set = value => {
        const v = Math.max(0, Math.min(100, value));
        comparison.style.setProperty('--p', `${v}%`);
        knob.setAttribute('aria-valuenow', Math.round(v));
        knob.setAttribute('aria-valuetext', `${Math.round(100 - v)}% frosted`);
        const x = v / 100 * comparison.clientWidth;
        const left = $('.mh-cmp-l'), right = $('.mh-cmp-r');
        comparison.classList.toggle('mh-hide-l', x < left.offsetLeft + left.offsetWidth + 8);
        comparison.classList.toggle('mh-hide-r', x > right.offsetLeft - 8);
      };
      resetComparison = () => { hinted = true; set(50); };
      const input = () => { hinted = true; if (!used) { used = true; track('home_compare_slide'); } };
      const fromX = x => { const r = comparison.getBoundingClientRect(); set((x - r.left) / r.width * 100); };
      on(comparison, 'pointerdown', e => {
        if (e.button !== 0 || e.target.closest('a')) return;
        input(); drag = true; comparison.setPointerCapture(e.pointerId); fromX(e.clientX);
        comparison.classList.add('mh-is-drag'); knob.focus({ preventScroll: true });
      });
      on(comparison, 'pointermove', e => { if (drag) fromX(e.clientX); });
      const end = () => { drag = false; comparison.classList.remove('mh-is-drag'); };
      on(comparison, 'pointerup', end); on(comparison, 'pointercancel', end); on(comparison, 'lostpointercapture', end);
      on(knob, 'keydown', e => {
        const delta = { ArrowLeft: -5, ArrowRight: 5, Home: -100, End: 100 }[e.key];
        if (delta === undefined) return;
        e.preventDefault(); input();
        set(Math.abs(delta) === 100 ? (delta < 0 ? 0 : 100) : +knob.getAttribute('aria-valuenow') + delta);
      });
      on(window, 'resize', () => set(+knob.getAttribute('aria-valuenow')));
      set(50);
      if (motion() && !window.Shopify?.designMode) {
        const observer = observe(comparison, entries => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          const start = performance.now();
          const tick = time => {
            const f = (time - start) / 1100;
            if (hinted || !motion()) return;
            if (f >= 1) { set(50); return; }
            set(50 + Math.sin(f * Math.PI * 2) * 12 * (1 - f)); frame(tick);
          };
          frame(tick);
        }, { threshold: .6 });
      }
    }

    const reviews = $$('.mh-rv-card');
    const carousel = $('.mh-rv-track');
    let closeDialog = () => {};
    if (carousel) {
      const previous = $('[data-mh-prev]'), next = $('[data-mh-next]'), bar = $('.mh-rv-prog span');
      const readMore = () => reviews.forEach(card => {
        const text = card.querySelector('.mh-rv-t');
        card.querySelector('.mh-rv-more').classList.toggle('mh-is-off', text.scrollHeight <= text.clientHeight + 2);
      });
      const sync = () => {
        previous.disabled = carousel.scrollLeft < 4;
        next.disabled = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4;
        bar.style.width = `${Math.min(100, (carousel.scrollLeft + carousel.clientWidth) / Math.max(1, carousel.scrollWidth) * 100)}%`;
        readMore();
      };
      const step = () => {
        const width = reviews[0]?.getBoundingClientRect().width || carousel.clientWidth;
        const gap = parseFloat(getComputedStyle(carousel).columnGap) || 0;
        return (width + gap) * Math.max(1, Math.floor((carousel.clientWidth + gap) / (width + gap)));
      };
      on(previous, 'click', () => carousel.scrollBy({ left: -step(), behavior: behavior() }));
      on(next, 'click', () => carousel.scrollBy({ left: step(), behavior: behavior() }));
      on(carousel, 'scroll', sync, { passive: true }); on(window, 'resize', sync); sync();
      document.fonts?.ready.then(() => { if (!controller.signal.aborted) sync(); });
      const modal = $('.mh-rvm'), box = $('.mh-rvm-box');
      let index = 0, opener = null, bodyState;
      const m = selector => modal.querySelector(selector);
      const fill = i => {
        index = i;
        const card = reviews[i];
        const photo = m('.mh-rvm-media img');
        if (card.dataset.mhPhoto) photo.src = card.dataset.mhPhoto; else photo.removeAttribute('src');
        photo.alt = `Customer photo from ${card.querySelector('.mh-rv-n').textContent}`;
        [i - 1, i + 1].forEach(n => { if (reviews[n]?.dataset.mhPhoto) new Image().src = reviews[n].dataset.mhPhoto; });
        m('.mh-rvm-n').textContent = card.querySelector('.mh-rv-n').textContent;
        const date = m('.mh-rvm-date');
        const rawDate = card.dataset.mhDate;
        const parsedDate = /^\d{4}-\d{2}-\d{2}$/.test(rawDate) ? new Date(`${rawDate}T12:00:00`) : null;
        date.textContent = parsedDate && !Number.isNaN(+parsedDate) ? parsedDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : rawDate;
        if (parsedDate && !Number.isNaN(+parsedDate)) date.dateTime = rawDate; else date.removeAttribute('datetime');
        m('.mh-stars').replaceChildren(...[...card.querySelector('.mh-stars').childNodes].map(n => n.cloneNode(true)));
        m('.mh-stars').setAttribute('aria-label', `${card.dataset.mhStars} out of 5 stars`);
        m('.mh-rv-m').replaceChildren(...[...card.querySelector('.mh-rv-m').childNodes].map(n => n.cloneNode(true)));
        m('.mh-rvm-t').textContent = card.querySelector('.mh-rv-t').textContent;
        m('.mh-rvm-note').hidden = card.dataset.mhRewarded !== 'true';
        const product = card.querySelector('.mh-rv-p'), destination = m('.mh-rvm-p');
        destination.hidden = !product;
        if (product) {
          destination.href = product.href;
          const image = m('.mh-rvm-p img');
          image.hidden = !product.dataset.mhProductImage;
          if (product.dataset.mhProductImage) image.src = product.dataset.mhProductImage; else image.removeAttribute('src');
          m('.mh-rvm-p .mh-model').textContent = product.querySelector('.mh-model').textContent;
          m('.mh-rvm-pn').textContent = product.querySelector('.mh-rv-pn').textContent;
        }
        m('.mh-rvm-nav span').textContent = `${i + 1} / ${reviews.length}`;
        m('[data-mh-dialog-prev]').disabled = i === 0;
        m('[data-mh-dialog-next]').disabled = i === reviews.length - 1;
        m('.mh-rvm-scroll').scrollTop = 0;
      };
      closeDialog = () => {
        if (modal.hidden) return;
        modal.hidden = true;
        document.body.style.overflow = bodyState.overflow;
        document.body.style.paddingRight = bodyState.paddingRight;
        if (opener?.isConnected) opener.focus({ preventScroll: true });
      };
      const open = (i, from) => {
        opener = from; fill(i); modal.hidden = false;
        bodyState = { overflow: document.body.style.overflow, paddingRight: document.body.style.paddingRight };
        const scrollbar = innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden';
        if (scrollbar > 0) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + scrollbar}px`;
        box.focus(); track('home_review_open', { reviewer: reviews[i].querySelector('.mh-rv-n').textContent });
      };
      reviews.forEach((card, i) => on(card.querySelector('.mh-rv-open'), 'click', e => open(i, e.currentTarget)));
      $$('[data-mh-close]').forEach(button => on(button, 'click', closeDialog));
      on(m('[data-mh-dialog-prev]'), 'click', () => { if (index > 0) fill(index - 1); });
      on(m('[data-mh-dialog-next]'), 'click', () => { if (index < reviews.length - 1) fill(index + 1); });
      on(window, 'keydown', e => {
        if (modal.hidden) return;
        if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); closeDialog(); }
        else if (e.key === 'ArrowLeft' && index > 0) fill(index - 1);
        else if (e.key === 'ArrowRight' && index < reviews.length - 1) fill(index + 1);
        else if (e.key === 'Tab') {
          const focusable = [...box.querySelectorAll('button:not([disabled]), a[href]')].filter(el => el.getClientRects().length);
          const first = focusable[0], last = focusable.at(-1);
          if (!box.contains(document.activeElement) || (e.shiftKey && [first, box].includes(document.activeElement))) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && [last, box].includes(document.activeElement)) { e.preventDefault(); first.focus(); }
        }
      }, { capture: true });
      on(document, 'focusin', e => { if (!modal.hidden && !box.contains(e.target)) box.focus(); });
      cleanups.push(closeDialog);
    }

    const questions = $$('.mh-fq');
    let faqBusy = false;
    const setQuestion = (item, opening, user = false) => {
      if (!item || faqBusy) return;
      const summary = item.querySelector('summary');
      const y = summary.getBoundingClientRect().top;
      const hold = () => { const dy = summary.getBoundingClientRect().top - y; if (Math.abs(dy) > .5) window.scrollBy({ top: dy, behavior: 'instant' }); };
      const closing = questions.filter(other => other.open && (other !== item || !opening));
      const finish = () => { closing.forEach(other => other.open = false); item.open = opening; hold(); faqBusy = false; };
      if (opening && user) track('home_faq_open', { question: summary.textContent.trim() });
      if (!motion() || !user) { finish(); return; }
      faqBusy = true;
      const jobs = [];
      closing.forEach(other => {
        const answer = other.querySelector('.mh-fq-a');
        jobs.push(animate(answer, [{ height: `${answer.offsetHeight}px`, opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 250, easing: 'cubic-bezier(.2,.7,.2,1)' }).finished.catch(() => {}));
      });
      if (opening) {
        item.open = true;
        const answer = item.querySelector('.mh-fq-a');
        jobs.push(animate(answer, [{ height: '0px', opacity: 0 }, { height: `${answer.offsetHeight}px`, opacity: 1 }], { duration: 250, easing: 'cubic-bezier(.2,.7,.2,1)' }).finished.catch(() => {}));
      }
      const tick = () => { hold(); if (faqBusy) frame(tick); };
      frame(tick);
      Promise.all(jobs).then(() => { if (!controller.signal.aborted) finish(); });
    };
    questions.forEach(item => on(item.querySelector('summary'), 'click', e => { e.preventDefault(); setQuestion(item, !item.open, true); }));

    const seoButton = $('.mh-seo-more'), seoBody = $('.mh-seo-body');
    if (seoBody) {
      if (!seoButton) seoBody.classList.add('mh-open');
      else {
        root.dataset.mhSeoCollapse = 'true';
        on(seoButton, 'click', () => {
        const open = seoBody.classList.toggle('mh-open');
        seoButton.setAttribute('aria-expanded', String(open)); seoButton.textContent = open ? 'Show less' : 'Read more';
        });
      }
    }

    const video = $('.mh-hero-video');
    if (video) {
      const desktop = matchMedia('(min-width: 821px)');
      const button = $('.mh-video-pause');
      let visible = false, pausedByUser = false, loaded = false;
      const syncVideo = () => {
        const play = desktop.matches && motion() && !window.Shopify?.designMode && visible && !document.hidden && !pausedByUser;
        if (play) {
          if (!loaded) { video.querySelectorAll('[data-mh-src]').forEach(source => source.src = source.dataset.mhSrc); video.load(); loaded = true; }
          video.play().then(() => root.classList.add('mh-video-playing')).catch(() => root.classList.remove('mh-video-playing'));
        } else { video.pause(); root.classList.remove('mh-video-playing'); }
        button.textContent = pausedByUser ? 'Play' : 'Pause';
        button.setAttribute('aria-label', pausedByUser ? 'Play video' : 'Pause video');
        button.setAttribute('aria-pressed', String(pausedByUser));
      };
      observe(video, entries => { visible = entries[0].isIntersecting; syncVideo(); });
      on(button, 'click', () => { pausedByUser = !pausedByUser; syncVideo(); });
      on(desktop, 'change', syncVideo); on(reduced, 'change', syncVideo); on(document, 'visibilitychange', syncVideo);
      cleanups.push(() => { video.pause(); video.querySelectorAll('source').forEach(source => source.removeAttribute('src')); video.load(); });
    }

    if (motion() && !window.Shopify?.designMode) {
      const candidates = $$('.mh-head, .mh-group, .mh-op, .mh-pcard, .mh-all, .mh-rv-head, .mh-rv-card, .mh-custom > *, .mh-fq-side, .mh-fq-list');
      const todo = candidates.filter(element => {
        const rect = element.getBoundingClientRect();
        return rect.top >= innerHeight && rect.left < innerWidth && rect.right > 0;
      });
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target); entry.target.classList.add('mh-in', 'mh-seen');
        later(() => { entry.target.classList.remove('mh-rv', 'mh-in'); entry.target.style.removeProperty('--d'); }, 850);
      }), { rootMargin: '0px 0px -8% 0px' });
      observers.push(observer);
      todo.forEach(element => {
        const siblings = [...element.parentElement.children].filter(el => todo.includes(el));
        element.style.setProperty('--d', `${Math.min(siblings.indexOf(element), 5) * 60}ms`);
        element.style.transition = 'none'; element.classList.add('mh-rv');
      });
      if (todo.length) {
        root.offsetWidth;
        todo.forEach(element => { element.style.transition = ''; observer.observe(element); });
      }
    }
    const selectBlock = target => {
      const question = target.closest('.mh-fq');
      if (question) setQuestion(question, true);
      const review = target.closest('.mh-rv-card');
      if (review && carousel) {
        carousel.scrollTo({ left: carousel.scrollLeft + review.getBoundingClientRect().left - carousel.getBoundingClientRect().left, behavior: 'instant' });
      }
      if (target.closest('.mh-measure') || root.dataset.mhSection === 'custom') resetComparison();
    };
    const trustBar = root.dataset.mhSection === 'trust' && $('.mh-trust');
    if (trustBar) {
      observe(trustBar, entries => document.body.classList.toggle('mh-chat-yield', entries.at(-1).isIntersecting));
      cleanups.push(() => document.body.classList.remove('mh-chat-yield'));
    }
    instances.set(root, {
      selectBlock,
      selectSection() { resetComparison(); },
      deselect() { closeDialog(); },
      destroy() {
        controller.abort(); observers.forEach(observer => observer.disconnect());
        frames.forEach(cancelAnimationFrame); timers.forEach(clearTimeout); animations.forEach(a => a.cancel());
        cleanups.forEach(cleanup => cleanup());
        $$('.mh-rv, .mh-in, .mh-seen').forEach(el => { el.classList.remove('mh-rv', 'mh-in', 'mh-seen'); el.style.removeProperty('--d'); });
        root.removeAttribute('data-mh-motion'); root.removeAttribute('data-mh-seo-collapse'); instances.delete(root);
      }
    });
  }

  const roots = target => [...(target.matches?.('[data-mh-section]') ? [target] : []), ...target.querySelectorAll('[data-mh-section]')];
  const scan = (target = document) => roots(target).forEach(init);
  window.MCOCODHome = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true }); else scan();
  document.addEventListener('shopify:section:load', e => scan(e.target));
  document.addEventListener('shopify:section:unload', e => roots(e.target).forEach(root => instances.get(root)?.destroy()));
  document.addEventListener('shopify:section:select', e => roots(e.target).forEach(root => instances.get(root)?.selectSection()));
  document.addEventListener('shopify:block:select', e => {
    const root = e.target.closest('[data-mh-section]'); instances.get(root)?.selectBlock(e.target);
  });
  document.addEventListener('shopify:block:deselect', e => {
    const root = e.target.closest('[data-mh-section]'); instances.get(root)?.deselect();
  });
})();
